

















































































import { Tracer, Analyze } from 'thor-tracer'
import Params from './components/params.vue'
import { Component, Vue } from 'vue-property-decorator'
import { getTokens } from './tokens'
import { abi } from 'thor-devkit'

@Component({
    components: {
        Params
    }
})
export default class App extends Vue {
    get eventResult() {
        return this.eventList.map(item => {
            return {
                ...item,
                ...this.blocks[item.blockId],
                name: this.tokensObj[item.address].name,
                icon: `https://vechain.github.io/token-registry/assets/${this.tokensObj[item.address].icon}`
            }
        })
    }
    private tokens: any[] = []
    private tokensObj: any = {}
    private address: string[] = []

    private start?: Connex.Thor.Status['head'] | null = null
    private stop?: Connex.Thor.Status['head'] | null = null

    private tracer?: Tracer

    private eventList: any[] = []
    private checkNum = 12

    private isStoped = true

    private blocks: any = {}

    private eventAbi = new abi.Event({
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: '_from',
                type: 'address'
            },
            {
                indexed: true,
                name: '_to',
                type: 'address'
            },
            {
                indexed: false,
                name: '_value',
                type: 'uint256'
            }
        ],
        name: 'Transfer',
        type: 'event'
    })

    public getRowStyle(num: number) {
        return `background: linear-gradient(to right, rgba(32, 156, 238, 0.2) ${num / this.checkNum * 100}%, transparent ${num / this.checkNum * 100}%);`
    }
    public inAccount(address: string) {
        return this.address.indexOf(address) > -1
    }

    public getCondations(data: any) {
        const tokens: string[] = data.tokens
        const address: string[] = data.accounts
        this.address = data.accounts
        this.tracer = new Tracer({
            filter: {
                transfer: false
            },
            eventFilter: (item) => {
                if (tokens.indexOf(item.address) > -1) {
                    const dec = this.eventAbi.decode(item.data, item.topics)
                    return address.length
                        ? (address.indexOf(dec._from) > -1 || address.indexOf(dec._to) > -1)
                        : true
                } else {
                    return false
                }
            }
        }, connex)
        this.tracer.setCheckNum(this.checkNum)
        this.bindEvent()
        this.tracer.start()
    }

    public bindEvent() {
        if (this.tracer) {
            this.tracer.events.on('caught', (r: Analyze.blockResult) => {
                const blockId = r.blockId
                const temp = r.events.map(item => {
                    return {
                        address: item.address,
                        txId: item.txId,
                        blockId,
                        decode: this.eventAbi.decode(item.data, item.topics)
                    }
                })
                this.eventList = [...this.eventList, ...temp]
            })
            this.tracer.events.on('start', (result: Connex.Thor.Status['head']) => {
                this.isStoped = false
                this.start = result
                this.stop = null
            })
            this.tracer.events.on('stop', (result: Connex.Thor.Status['head']) => {
                this.isStoped = true
                this.stop = result
            })

            this.tracer.events.on('confirm', (list: Tracer.confirmed[]) => {
                this.blocks = {}
                list.forEach((item: Tracer.confirmed) => {
                    if (!item.isTrunk || item.confirm < this.tracer!.CheckNum) {
                        this.blocks[item.blockID] = {
                            isTrunk: item.isTrunk,
                            confirm: item.confirm
                        }
                    }
                })
                const blockIDs = Object.keys(this.blocks)
                this.eventList = this.eventList.filter(item => {
                    return blockIDs.indexOf(item.blockId) > -1
                })
            })
        }
    }

    public stopTracer() {
        this.tracer!.stop()
        this.tracer!.events.removeAllListeners(['start', 'stop', 'caught', 'confirm'])
    }

    private async beforeCreate() {
        const net = connex.thor.genesis.id === '0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a' ? 'main' : 'test'
        this.tokens = await getTokens(net)

        this.tokens.forEach(item => {
            this.tokensObj[item.address] = item
        })
    }
}
